import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Credentials } from '../models/login-models';
import { finalize } from 'rxjs/operators';
import { AuthenticationService } from '../auth/authentication.service';
import { environment } from '@env/environment';
import { LoaderGenericService } from '@app/@shared/loader-generic/loader-generic.service';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

const urlsNotIntercepted: string[] = [
  environment.subUrlLogin,
  environment.subUrlLatestRequestsHome,
  'request/api/product/.+',
  environment.subUrlDetailRequestConsumo,
  environment.subUrlHistoric,
  environment.subUrlDocumentation,
  environment.subUrlDetailRequestCard,
  environment.subUrlDetailRequestMangoNS,
  environment.subUrlDetailRequestMango,
  environment.subUrlDetailRequestAutos,
  environment.subUrlPrescribers,
  environment.subUrlEstablishments,
  environment.subUrlDivision,
  environment.subURlChains,
  environment.subUrlOffices,
  environment.subUrlControlPanelProduct,
  environment.subUrlControlPanelArticles,
  environment.subUrlControlPanelExternalCommercialByCase,
  environment.subUrlControlPanelOrigins,
  environment.subUrlControlPanelStatus,
  environment.subUrlGetExternalCommercial,
  environment.subUrlGetDivisions,
  environment.subUrlGetProfilesUsers,
  environment.subUrlgetSearchUsers,
  environment.subUrlGetBrands,
  environment.subUrlGetUserType,
  environment.subUrlGetDetailUser,
  environment.subUrlGetAttributionsUser,
  environment.subUrlGetUserTreeByUser,
  environment.subUrlGetPasswordWS,
  environment.subUrlCreateUser,
  environment.subUrlVendorByFilter,
  environment.subUrlDeleteUser,
  environment.subUrlModifyUser,
  environment.subUrlGetUserDetailById,
  environment.subUrlGetUserDetailByUserName,
  environment.subUrlImpersonatedUserByFilter,
  environment.subUrlActivityStatus,
  environment.subUrlActivityMacrosExcel,
];

@Injectable({
  providedIn: 'root',
})
export class ApiPrefixInterceptor implements HttpInterceptor {
  constructor(
    private loaderGenericService: LoaderGenericService,
    private router: Router,
    private cookieService: CookieService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isValidRequest = this.isValidRequestForInterceptor(request.url);
    const JWT_TOKEN = this.cookieService.get('JWT_ACCESS_COOKIE');
    if (environment.name === 'local-pre' && JWT_TOKEN) {
      request = this.addToken(request, JWT_TOKEN);
    }
    if (isValidRequest) {
      this.loaderGenericService.showSpinner();
    }

    return isValidRequest
      ? next.handle(request).pipe(finalize(() => this.loaderGenericService.stopSpinner()))
      : next.handle(request);
  }

  private addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
    return req.clone({ headers: req.headers.set('Authorization', 'Bearer ' + token) });
  }

  private isValidRequestForInterceptor(requestUrl: string): boolean {
    if (requestUrl.includes(environment.subUrlrefreshToken)) return false;

    let positionIndicator: string = environment.server;
    let position = requestUrl.indexOf(positionIndicator);

    if (position > 0) {
      let destination: string = requestUrl.substr(position + positionIndicator.length);
      for (let address of urlsNotIntercepted) {
        if (destination === 'request/panel/main/operations') {
          return false;
        } else if (this.router.url.includes('users/register-user')) {
          return true;
        } else {
          if (!destination.includes('request/panel/main/operations') && new RegExp(address).test(destination)) {
            return false;
          }
        }
      }
    }
    return true;
  }
}
